// Módulo específico, e não o barril `@plone/volto/helpers`: o barril arrasta
// `Html.jsx` -> `serialize-javascript`, que exige `crypto` global e derruba
// qualquer suíte de teste que só precise deste utilitário.
import {
  difference,
  replaceItemOfArray,
} from '@plone/volto/helpers/Utils/Utils';
import { compact } from 'lodash';

/**
 * Base dos `dataAdapter` de blocos com lista de itens (`object_list`).
 *
 * Detecta quando o `href` de UM item mudou (ou seja, o editor acabou de
 * escolher um conteúdo) e delega a `buildPatch` decidir quais campos daquele
 * item devem ser preenchidos a partir do brain selecionado. Sem `buildPatch`
 * o comportamento é o de sempre: apenas grava o valor.
 *
 * `isReordering` protege o caso de arrastar itens na lista, em que vários
 * índices mudam de uma vez e nenhum autofill deve rodar.
 *
 * @param {function} [buildPatch] `(brain, item) => Partial<item>`
 */
export const blockAdapterBase = (
  block,
  data,
  id,
  onChangeBlock,
  value,
  dictId,
  buildPatch,
) => {
  let dataSaved = {
    ...data,
    [id]: value,
  };
  if (id === dictId && data[id]) {
    const diff = difference(value, data[id]);
    const isReordering = compact(diff).length > 1;
    if (!isReordering) {
      const index = diff.findIndex((val) => val);
      const brain = diff[index]?.href?.[0];
      if (brain) {
        const patch = buildPatch ? buildPatch(brain, value[index]) : {};
        dataSaved = {
          ...dataSaved,
          [dictId]: replaceItemOfArray(value, index, {
            ...value[index],
            ...patch,
          }),
        };
      }
    }
  }
  onChangeBlock(block, dataSaved);
};
